// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ed1c8518","703":"0d6cd222","787":"469d17a3"}[chunkId] + ".chunk.js";
};